export const refs = {
  checkbox: document.querySelector('.checkbox'),
  body: document.querySelector('body'),
};
